import React, { useState } from 'react';
import { MessageCircle, X } from 'lucide-react';
import { contactInfo } from '../mock/fareData';

const WhatsAppButton = () => {
  const [showOptions, setShowOptions] = useState(false);

  const handleWhatsAppClick = (number) => {
    // Format: Clean phone number (remove spaces, dashes, parentheses)
    const cleanNumber = number.replace(/[^0-9]/g, '');
    
    // Pre-filled message
    const message = encodeURIComponent('Hello Taxi-98, I would like to book a ride. Please assist me with availability.');
    
    // WhatsApp Business link
    const whatsappUrl = `https://wa.me/${cleanNumber}?text=${message}`;
    
    // Open in new window/tab
    window.open(whatsappUrl, '_blank');
    setShowOptions(false);
  };

  return (
    <>
      {/* WhatsApp Business Floating Button — 2026-06-05: mobile size/offset reduced
          so the button no longer overlaps hero trust points or CTAs on small screens. */}
      <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50">
        {/* Options Menu */}
        {showOptions && (
          <div className="absolute bottom-20 right-0 bg-white rounded-2xl shadow-2xl border-2 border-green-500 p-4 mb-2 min-w-[280px]">
            <div className="flex items-center justify-between mb-3 pb-2 border-b border-gray-200">
              <h3 className="text-sm font-bold text-gray-900">Choose WhatsApp Line</h3>
              <button
                onClick={() => setShowOptions(false)}
                className="text-gray-400 hover:text-gray-600 transition"
              >
                <X className="w-4 h-4" />
              </button>
            </div>
            
            {/* WhatsApp Option 1 - Business */}
            <button
              onClick={() => handleWhatsAppClick(contactInfo.whatsapp)}
              className="w-full flex items-center space-x-3 p-3 rounded-lg hover:bg-green-50 transition group mb-2"
            >
              <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                <MessageCircle className="w-5 h-5 text-white" />
              </div>
              <div className="text-left">
                <p className="text-sm font-semibold text-gray-900 group-hover:text-green-600">Business</p>
                <p className="text-xs text-gray-500">+1 (242) 810-7335</p>
              </div>
            </button>

            {/* WhatsApp Option 2 - Management */}
            <button
              onClick={() => handleWhatsAppClick(contactInfo.whatsapp2)}
              className="w-full flex items-center space-x-3 p-3 rounded-lg hover:bg-green-50 transition group"
            >
              <div className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                <MessageCircle className="w-5 h-5 text-white" />
              </div>
              <div className="text-left">
                <p className="text-sm font-semibold text-gray-900 group-hover:text-green-600">Management</p>
                <p className="text-xs text-gray-500">+1 (242) 810-0098</p>
              </div>
            </button>
          </div>
        )}

        {/* Main Button */}
        <button
          onClick={() => setShowOptions(!showOptions)}
          className="relative group"
          aria-label="Chat on WhatsApp Business"
        >
          {/* Pulse Animation Ring */}
          {!showOptions && (
            <div className="absolute inset-0 bg-green-500 rounded-full animate-ping opacity-75"></div>
          )}
          
          {/* Button */}
          <div className={`relative bg-green-500 hover:bg-green-600 text-white p-3 sm:p-4 rounded-full shadow-2xl transition-all duration-300 transform hover:scale-110 ${showOptions ? 'scale-110 bg-green-600' : ''}`}>
            <MessageCircle className="w-6 h-6 sm:w-7 sm:h-7" />
          </div>
          
          {/* Hover Tooltip */}
          {!showOptions && (
            <span className="absolute -top-14 right-0 bg-gray-900 text-white px-4 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none shadow-xl">
              <span className="block font-bold text-green-400">WhatsApp Business</span>
              <span className="block text-xs text-gray-300">2 Lines Available</span>
              {/* Arrow */}
              <span className="absolute bottom-[-6px] right-4 w-3 h-3 bg-gray-900 transform rotate-45"></span>
            </span>
          )}
        </button>
      </div>
    </>
  );
};

export default WhatsAppButton;
